import { useState, useRef, useEffect } from "react";
import { Send } from "lucide-react";

export const ChatbotInput = ({ onSend, disabled, autoFocus }) => {
  const [value, setValue] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      const t = window.setTimeout(() => inputRef.current?.focus(), 200);
      return () => window.clearTimeout(t);
    }
    return undefined;
  }, [autoFocus]);

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    setValue("");
    onSend(trimmed);
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className="p-3 border-t border-slate-200 bg-white">
      <div className="flex items-end gap-2">
        <textarea
          ref={inputRef}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKey}
          rows={1}
          placeholder="Tapez votre question…"
          data-testid="chatbot-input"
          className="flex-1 resize-none rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 max-h-24"
        />
        <button
          type="button"
          onClick={submit}
          disabled={disabled || !value.trim()}
          aria-label="Envoyer le message"
          data-testid="chatbot-send-btn"
          className="flex items-center justify-center w-10 h-10 rounded-lg bg-red-600 hover:bg-red-700 disabled:bg-slate-300 disabled:cursor-not-allowed text-white transition"
        >
          <Send className="h-4 w-4" />
        </button>
      </div>
      <p className="mt-1 text-[10px] text-slate-400 text-center">
        Réponses propulsées par l&apos;IA · Pour un devis ferme : 05 49 05 74 90
      </p>
    </div>
  );
};
